export const initLegalPersons = (data) => {
    var _a;
    const legalPersons = (_a = data.legalPersons) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, data), { legalPersons });
};
